import { render, staticRenderFns } from "./randomWord.vue?vue&type=template&id=9376a4c8&scoped=true"
import script from "./randomWord.vue?vue&type=script&lang=js"
export * from "./randomWord.vue?vue&type=script&lang=js"
import style0 from "./randomWord.vue?vue&type=style&index=0&id=9376a4c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9376a4c8",
  null
  
)

export default component.exports